export const categories = [
  { id: 'search-engine', name: '搜索引擎', icon: 'ri-search-line', description: '国内外主流搜索引擎官方最新入口，快速检索全网信息' },
  { id: 'social-media', name: '社交媒体', icon: 'ri-message-3-line', description: '各大社交平台官方最新网址，随时保持社交连接' },
  { id: 'video-platform', name: '视频平台', icon: 'ri-film-line', description: '主流视频网站官方最新入口，畅享精彩视听内容' },
  { id: 'shopping', name: '购物平台', icon: 'ri-shopping-cart-2-line', description: '电商平台官方最新网址，安全购物有保障' },
  { id: 'news', name: '新闻资讯', icon: 'ri-newspaper-line', description: '权威新闻媒体官方最新入口，获取实时资讯' },
  { id: 'learning', name: '学习资源', icon: 'ri-book-open-line', description: '优质学习平台官方最新网址，助力终身学习' },
  { id: 'tools', name: '工具资源', icon: 'ri-tools-line', description: '实用在线工具官方最新入口，提升工作效率' },
  { id: 'government', name: '政府服务', icon: 'ri-government-line', description: '政务服务平台官方最新网址，办事更便捷' },
];

export const sites = [
  // 搜索引擎
  { id: 's1', name: '百度', url: 'https://www.baidu.com', description: '全球最大的中文搜索引擎，提供网页、图片、视频等多种搜索服务', category: 'search-engine', tags: ['搜索', '中文搜索', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's2', name: 'Google', url: 'https://www.google.com', description: '全球最大的搜索引擎，提供全面的网页搜索及多种在线服务', category: 'search-engine', tags: ['搜索', '全球搜索'], isHot: true, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's3', name: '必应', url: 'https://www.bing.com', description: '微软推出的搜索引擎，集成AI智能搜索功能', category: 'search-engine', tags: ['搜索', 'AI搜索'], isHot: false, isNew: true, iconBg: 'bg-secondary-500' },
  { id: 's4', name: '搜狗搜索', url: 'https://www.sogou.com', description: '中国领先的中文搜索引擎，支持微信、知乎等专属搜索', category: 'search-engine', tags: ['搜索', '中文搜索'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
  { id: 's5', name: '360搜索', url: 'https://www.so.com', description: '360旗下搜索引擎，主打安全搜索体验', category: 'search-engine', tags: ['搜索', '安全搜索'], isHot: false, isNew: false, iconBg: 'bg-accent-400' },
  { id: 's6', name: 'DuckDuckGo', url: 'https://duckduckgo.com', description: '注重隐私保护的搜索引擎，不追踪用户搜索记录', category: 'search-engine', tags: ['搜索', '隐私保护'], isHot: false, isNew: true, iconBg: 'bg-primary-400' },
  // 社交媒体
  { id: 's7', name: '微信', url: 'https://weixin.qq.com', description: '腾讯旗下即时通讯与社交平台，支持朋友圈、公众号、小程序等', category: 'social-media', tags: ['社交', '即时通讯', '热门'], isHot: true, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's8', name: '微博', url: 'https://weibo.com', description: '中国最大的社交媒体平台之一，实时热点话题讨论社区', category: 'social-media', tags: ['社交', '热搜'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's9', name: '知乎', url: 'https://www.zhihu.com', description: '高质量中文问答社区，汇聚各领域专业人士的知识分享', category: 'social-media', tags: ['问答', '知识社区'], isHot: false, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's10', name: '豆瓣', url: 'https://www.douban.com', description: '书影音评社区，提供图书、电影、音乐的评价与推荐', category: 'social-media', tags: ['书影音', '社区'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
  { id: 's11', name: '小红书', url: 'https://www.xiaohongshu.com', description: '生活方式分享社区，涵盖美妆、穿搭、旅行、美食等内容', category: 'social-media', tags: ['生活方式', '种草'], isHot: true, isNew: false, iconBg: 'bg-primary-400' },
  // 视频平台
  { id: 's12', name: '哔哩哔哩', url: 'https://www.bilibili.com', description: '中国年轻人聚集的视频社区，涵盖动画、游戏、知识等内容', category: 'video-platform', tags: ['视频', '弹幕', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's13', name: '抖音', url: 'https://www.douyin.com', description: '领先的短视频社交平台，记录美好生活瞬间', category: 'video-platform', tags: ['短视频', '热门'], isHot: true, isNew: false, iconBg: 'bg-foreground-500' },
  { id: 's14', name: '优酷', url: 'https://www.youku.com', description: '阿里巴巴旗下视频平台，提供海量影视剧、综艺、动漫内容', category: 'video-platform', tags: ['长视频', '影视'], isHot: false, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's15', name: '腾讯视频', url: 'https://v.qq.com', description: '腾讯旗下在线视频平台，拥有丰富的独家影视内容', category: 'video-platform', tags: ['长视频', '影视'], isHot: false, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's16', name: '爱奇艺', url: 'https://www.iqiyi.com', description: '中国领先的在线视频平台，提供正版高清影视内容', category: 'video-platform', tags: ['长视频', '影视'], isHot: false, isNew: false, iconBg: 'bg-accent-400' },
  // 购物平台
  { id: 's17', name: '淘宝', url: 'https://www.taobao.com', description: '中国最大的电商零售平台，商品种类丰富，万能的购物平台', category: 'shopping', tags: ['电商', '综合购物', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's18', name: '京东', url: 'https://www.jd.com', description: '以自营为核心的品质电商平台，主打正品保证与快速物流', category: 'shopping', tags: ['电商', '正品保证'], isHot: true, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's19', name: '拼多多', url: 'https://www.pinduoduo.com', description: '新电商开创者，通过拼团模式为用户提供高性价比商品', category: 'shopping', tags: ['电商', '拼团'], isHot: false, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's20', name: '苏宁易购', url: 'https://www.suning.com', description: '线上线下融合的智慧零售平台，家电3C品类齐全', category: 'shopping', tags: ['电商', '家电'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
  // 新闻资讯
  { id: 's21', name: '新华网', url: 'https://www.xinhuanet.com', description: '国家通讯社主办的综合新闻信息门户，权威新闻来源', category: 'news', tags: ['新闻', '官方媒体', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's22', name: '人民网', url: 'https://www.people.com.cn', description: '人民日报建设的以新闻为主的大型网上信息交互平台', category: 'news', tags: ['新闻', '官方媒体'], isHot: false, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's23', name: '今日头条', url: 'https://www.toutiao.com', description: '基于数据挖掘的智能推荐资讯平台，个性化内容推送', category: 'news', tags: ['新闻', '智能推荐'], isHot: true, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's24', name: '澎湃新闻', url: 'https://www.thepaper.cn', description: '专注时政与思想的互联网新闻平台，深度原创报道', category: 'news', tags: ['新闻', '深度报道'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
  // 学习资源
  { id: 's25', name: '中国大学MOOC', url: 'https://www.icourse163.org', description: '汇集国内顶尖高校优质课程，免费在线学习平台', category: 'learning', tags: ['教育', '公开课', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's26', name: '网易公开课', url: 'https://open.163.com', description: '汇集全球名校公开课与TED演讲，免费知识分享平台', category: 'learning', tags: ['教育', '公开课'], isHot: false, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's27', name: 'CSDN', url: 'https://www.csdn.net', description: '全球知名中文IT技术交流平台，开发者学习与分享社区', category: 'learning', tags: ['技术', '开发者'], isHot: false, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's28', name: '学堂在线', url: 'https://www.xuetangx.com', description: '清华大学发起的中文MOOC平台，提供优质的在线课程资源', category: 'learning', tags: ['教育', 'MOOC'], isHot: false, isNew: true, iconBg: 'bg-foreground-500' },
  // 工具资源
  { id: 's29', name: '百度网盘', url: 'https://pan.baidu.com', description: '国内最大的个人云存储服务平台，支持文件备份与分享', category: 'tools', tags: ['云存储', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's30', name: '石墨文档', url: 'https://shimo.im', description: '新一代在线协作文档工具，支持多人实时编辑', category: 'tools', tags: ['协作', '文档'], isHot: false, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's31', name: 'ProcessOn', url: 'https://www.processon.com', description: '专业在线作图工具，支持流程图、思维导图等多种图形', category: 'tools', tags: ['作图', '思维导图'], isHot: false, isNew: true, iconBg: 'bg-secondary-500' },
  { id: 's32', name: 'IconFont', url: 'https://www.iconfont.cn', description: '阿里巴巴矢量图标库，提供丰富的矢量图标资源', category: 'tools', tags: ['设计', '图标'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
  // 政府服务
  { id: 's33', name: '国家政务服务平台', url: 'https://gjzwfw.www.gov.cn', description: '全国一体化在线政务服务平台，一网通办各类政务服务', category: 'government', tags: ['政务', '一网通办', '热门'], isHot: true, isNew: false, iconBg: 'bg-primary-500' },
  { id: 's34', name: '国家税务总局', url: 'https://www.chinatax.gov.cn', description: '国家税务总局官方网站，提供税务政策查询与在线办税服务', category: 'government', tags: ['税务', '办税'], isHot: false, isNew: false, iconBg: 'bg-accent-500' },
  { id: 's35', name: '国家企业信用信息公示系统', url: 'https://www.gsxt.gov.cn', description: '查询企业信用信息、经营异常名录等权威平台', category: 'government', tags: ['企业查询', '信用'], isHot: false, isNew: false, iconBg: 'bg-secondary-500' },
  { id: 's36', name: '中国裁判文书网', url: 'https://wenshu.court.gov.cn', description: '最高人民法院建设的裁判文书公开平台', category: 'government', tags: ['法律', '裁判文书'], isHot: false, isNew: false, iconBg: 'bg-foreground-500' },
];

export const articles = [
  {
    id: 'a1',
    title: '2025年最值得收藏的搜索引擎最新网址大全',
    slug: '2025-search-engine-url-collection',
    summary: '本文整理了2025年国内外主流搜索引擎的最新官方网址入口，包括百度、Google、必应等平台，帮助你在信息海洋中快速定位所需内容。每个搜索引擎都有其独特优势，合理选择可以大幅提升搜索效率。',
    content: `<p>在互联网信息爆炸的时代，选择一个好的搜索引擎至关重要。本文将为您详细整理2025年国内外主流搜索引擎的<strong>最新官方网址入口</strong>，帮助您快速、准确地获取所需信息。</p>
<h2>一、国内主流搜索引擎</h2>
<p><strong>百度（Baidu）</strong>作为全球最大的中文搜索引擎，每天处理数以亿计的搜索请求。百度不仅提供网页搜索，还整合了百度百科、百度知道、百度地图等丰富的生态服务。对于中文内容的搜索，百度无疑是最佳选择。</p>
<p><strong>搜狗搜索</strong>凭借与微信、知乎等平台的深度合作，在社交媒体内容搜索方面具有独特优势。如果您需要搜索微信公众号文章或知乎问答，搜狗搜索是最佳工具。</p>
<p><strong>360搜索</strong>主打安全搜索体验，能够有效识别钓鱼网站和恶意链接，为您的上网安全保驾护航。</p>
<h2>二、国际搜索引擎</h2>
<p><strong>Google</strong>作为全球最大的搜索引擎，凭借其强大的算法和AI技术，能够提供高度精准的搜索结果。Google学术、Google图片等垂直搜索服务也是学术研究和设计灵感的重要来源。</p>
<p><strong>必应（Bing）</strong>在2025年深度整合了AI智能搜索功能，用户可以通过自然语言对话的方式获取信息和答案。此外，必应的图片搜索和视频搜索体验也非常出色。</p>
<h2>三、隐私保护型搜索引擎</h2>
<p><strong>DuckDuckGo</strong>近年来因其严格的隐私保护政策受到越来越多用户的青睐。它不会追踪用户的搜索记录，也不会根据用户画像推送个性化广告，是隐私意识用户的首选。</p>
<h2>四、选择搜索引擎的建议</h2>
<p>不同的搜索引擎各有优势，建议您根据实际需求灵活选择：中文内容优先使用百度或搜狗；全球资讯首选Google；注重隐私保护则推荐DuckDuckGo；AI智能搜索体验可以尝试必应。</p>
<p>收藏本文，您就拥有了2025年最全面的搜索引擎<strong>最新网址入口</strong>，告别失效链接困扰。</p>`,
    category: 'search-engine',
    tags: ['搜索引擎', '网址大全', '搜索技巧'],
    publishDate: '2025-08-10',
    author: '网址导航编辑部',
  },
  {
    id: 'a2',
    title: '社交媒体平台最新网址入口汇总（2025年8月更新）',
    slug: '2025-social-media-url-collection',
    summary: '全面汇总2025年国内主流社交媒体平台的最新官方网址，包括微信、微博、小红书、知乎等平台入口。无论是日常社交还是品牌营销，这些平台的官方入口都值得收藏。',
    content: `<p>社交媒体已经成为现代人生活中不可或缺的一部分。截至2025年，中国社交媒体用户已超过10亿。本文将为您整理<strong>各大社交媒体平台最新官方网址入口</strong>，确保您使用的是安全、可靠的官方渠道。</p>
<h2>一、即时通讯与社交</h2>
<p><strong>微信（WeChat）</strong>作为腾讯旗下的超级应用，不仅是中国最大的即时通讯工具，还整合了支付、小程序、公众号、视频号等丰富功能。微信已经成为中国人数字生活的核心入口。</p>
<p>微信网页版和PC版可以让您在工作时更方便地使用微信，实现手机与电脑之间的无缝衔接。</p>
<h2>二、内容社区与社交</h2>
<p><strong>微博（Weibo）</strong>是中国最具影响力的社交媒体平台之一，每天产生大量热点话题。无论是追踪明星动态、了解社会热点，还是参与话题讨论，微博都是首选平台。</p>
<p><strong>小红书（Xiaohongshu）</strong>以生活方式分享为核心，用户可以在平台上发现旅行攻略、美食推荐、穿搭灵感等优质内容。小红书的"种草"文化已经深刻影响了中国年轻消费者的购物决策。</p>
<p><strong>知乎（Zhihu）</strong>是高知用户聚集的问答社区。在这里，您可以找到各领域专家对各类问题的深度解答，是学习和拓展知识边界的宝贵资源。</p>
<h2>三、书影音社区</h2>
<p><strong>豆瓣（Douban）</strong>以其独特的书影音评分系统闻名。在决定看一部电影、读一本书之前，很多人习惯先上豆瓣查看评分和用户评价。豆瓣小组也是各类兴趣交流的活跃社区。</p>
<h2>四、安全使用社交媒体的建议</h2>
<p>在使用社交媒体时，务必通过<strong>官方最新网址入口</strong>访问平台，警惕仿冒网站和钓鱼链接。保护好个人隐私信息，不轻易点击来源不明的链接，是安全使用社交媒体的基本守则。</p>`,
    category: 'social-media',
    tags: ['社交媒体', '社交平台', '网址入口'],
    publishDate: '2025-08-08',
    author: '网址导航编辑部',
  },
  {
    id: 'a3',
    title: '视频平台最新网址导航：追剧看片不迷路',
    slug: '2025-video-platform-url-collection',
    summary: '整理2025年国内主流视频平台最新官方网址，涵盖B站、抖音、优酷、腾讯视频等。无论你是动漫爱好者、影视迷还是短视频创作者，这份网址导航都能帮你快速找到入口。',
    content: `<p>随着5G网络的普及和视频技术的进步，在线视频已经成为互联网流量消费的主体。本文将为您整理<strong>主流视频平台最新官方网址入口</strong>，帮助您畅享丰富多彩的视频内容。</p>
<h2>一、综合视频平台</h2>
<p><strong>哔哩哔哩（Bilibili）</strong>是中国年轻世代高度聚集的视频社区，以其独特的弹幕文化和丰富的内容生态著称。无论是番剧动画、游戏实况、知识科普还是创意短视频，B站都能满足您的需求。</p>
<p><strong>腾讯视频、优酷、爱奇艺</strong>三大长视频平台拥有海量的正版影视内容。热门电视剧、院线大片、综艺节目等都可以在这些平台上观看。</p>
<h2>二、短视频平台</h2>
<p><strong>抖音（Douyin）</strong>作为全球领先的短视频平台，以其智能推荐算法和丰富的创作工具吸引了数亿用户。在抖音，您可以发现最新潮流、学习实用技巧、记录美好生活。</p>
<h2>三、如何选择视频平台</h2>
<p>每个视频平台都有其独特的内容生态和用户群体。B站适合追求深度内容和社区互动的用户；抖音适合碎片化娱乐和轻松刷视频；而优酷、腾讯视频、爱奇艺则更偏向传统影视内容消费。</p>
<p>建议您多平台使用，根据不同的内容需求选择合适的平台，这样才能获得最佳的观影体验。</p>`,
    category: 'video-platform',
    tags: ['视频平台', '追剧', '短视频'],
    publishDate: '2025-08-06',
    author: '网址导航编辑部',
  },
  {
    id: 'a4',
    title: '电商购物平台官方最新网址汇总：安全购物第一站',
    slug: '2025-shopping-url-collection',
    summary: '整理了淘宝、京东、拼多多、苏宁易购等主流电商平台的官方最新网址入口。通过官方渠道购物，避免进入仿冒网站，保障您的资金安全与消费权益。',
    content: `<p>网购已经成为中国消费者最主要的购物方式之一。然而，网络上存在大量仿冒电商网站，稍有不慎就可能遭受损失。本文整理了<strong>主流电商平台官方最新网址入口</strong>，为您的安全购物保驾护航。</p>
<h2>一、综合电商平台</h2>
<p><strong>淘宝（Taobao）</strong>作为阿里巴巴旗下的C2C电商平台，拥有海量的商品种类，"万能淘宝"的称号名副其实。从日常生活用品到个性化定制商品，您几乎可以在淘宝上找到任何需要的东西。</p>
<p><strong>京东（JD.com）</strong>以自营模式为核心，在商品品质和物流速度方面具有明显优势。京东的"211限时达"服务让许多城市的用户可以在下单当天收到商品。</p>
<h2>二、社交电商</h2>
<p><strong>拼多多（Pinduoduo）</strong>通过创新的拼团模式和极致性价比策略，在竞争激烈的电商市场中开辟了独特赛道。对于价格敏感型消费者，拼多多是一个不错的选择。</p>
<h2>三、安全购物指南</h2>
<p>网购时务必注意以下几点：首先，始终通过<strong>官方最新网址入口</strong>访问购物平台；其次，不要点击短信、邮件中的陌生链接；第三，支付时确认页面地址栏显示安全锁标志；最后，收到商品后及时检查并确认收货。</p>
<p>收藏本文中的<strong>电商平台最新网址</strong>，让每一次网购都安心放心。</p>`,
    category: 'shopping',
    tags: ['电商', '购物安全', '网购攻略'],
    publishDate: '2025-08-04',
    author: '网址导航编辑部',
  },
  {
    id: 'a5',
    title: '政府服务平台最新网址大全：办事不再跑断腿',
    slug: '2025-government-service-url-collection',
    summary: '整理国家政务服务平台、税务、企业信用查询等政府服务平台的最新官方网址。在线办理政务事项，省时省力，让数据多跑路，让群众少跑腿。',
    content: `<p>随着"互联网+政务服务"的深入推进，越来越多的政务事项可以在线办理。<strong>政府服务平台最新网址入口</strong>的掌握，对于每一位公民和企业都至关重要。</p>
<h2>一、综合政务服务平台</h2>
<p><strong>国家政务服务平台</strong>是全国一体化在线政务服务的总枢纽，实现了"一网通办"的目标。无论是查询社保、办理护照、还是申请营业执照，都可以在这个平台上找到相应入口。</p>
<h2>二、专业政务服务</h2>
<p><strong>国家税务总局</strong>官方网站提供全方位的税务服务，包括个人所得税查询、企业税务申报、发票查验等功能。掌握税务平台的最新网址，可以大大节省办税时间。</p>
<p><strong>国家企业信用信息公示系统</strong>是企业信息查询的权威平台。在商务合作前，通过该平台查询合作方的信用状况，可以有效降低商业风险。</p>
<h2>三、使用建议</h2>
<p>使用政务服务平台时，请务必确认访问的是<strong>官方最新网址</strong>（通常以.gov.cn结尾）。切勿相信非官方渠道的收费代办服务，谨防诈骗。</p>`,
    category: 'government',
    tags: ['政务服务', '在线办事', '政府网站'],
    publishDate: '2025-08-02',
    author: '网址导航编辑部',
  },
  {
    id: 'a6',
    title: '在线学习平台最新网址推荐：终身学习者的必备收藏',
    slug: '2025-learning-platform-url-collection',
    summary: '推荐中国大学MOOC、网易公开课、CSDN、学堂在线等优质学习平台的最新官方网址入口。无论你想提升专业技能还是扩展知识面，这些平台都能助你一臂之力。',
    content: `<p>在知识经济时代，终身学习已经成为个人发展的必备素养。优质的<strong>在线学习平台最新网址入口</strong>，是每一位终身学习者的必备工具。</p>
<h2>一、高等教育资源</h2>
<p><strong>中国大学MOOC</strong>汇集了清华大学、北京大学、浙江大学等国内顶尖高校的优质课程。从计算机科学到人文艺术，从基础学科到前沿技术，丰富的课程资源满足了不同学习者的需求。</p>
<p><strong>学堂在线</strong>由清华大学发起，是国内最早的MOOC平台之一。平台上的课程质量高、体系完整，部分课程还可以获得认证证书。</p>
<h2>二、专业技能提升</h2>
<p><strong>CSDN</strong>是中文IT技术社区的第一品牌。无论是编程入门还是架构设计，从人工智能到区块链，CSDN上都有海量的技术文章、课程和问答资源。</p>
<p><strong>网易公开课</strong>汇集了TED演讲、国际名校公开课等优质内容，配有中文字幕，是学习英语和拓展国际视野的好帮手。</p>
<h2>三、学习建议</h2>
<p>建议学习者根据自己的学习目标选择合适的平台。在校学生可以充分利用MOOC平台补充课堂学习；职场人士可以通过CSDN等平台提升专业技能；而想要开阔视野的用户则可以多看看公开课和TED演讲。</p>`,
    category: 'learning',
    tags: ['在线学习', 'MOOC', '终身学习'],
    publishDate: '2025-07-30',
    author: '网址导航编辑部',
  },
];

export const faqs = [
  {
    id: 'faq1',
    question: '为什么要使用最新网址导航？',
    answer: '互联网平台的网址可能会因域名更换、系统升级等原因发生变化。使用最新网址导航，您可以确保访问的是各平台的官方最新网址入口，避免进入仿冒网站或失效链接，保障账号安全和访问效率。',
  },
  {
    id: 'faq2',
    question: '网站上的网址多久更新一次？',
    answer: '我们的编辑团队每日监控各平台网址变化，实时更新网址导航数据。一旦发现网址变更，我们会在24小时内完成更新，确保您获取的都是最新网址入口。同时，用户也可以通过反馈功能向我们报告失效链接。',
  },
  {
    id: 'faq3',
    question: '如何判断一个网址是否为官方网址？',
    answer: '判断官方网址可以从以下几个方面入手：1）查看域名，国内正规网站通常以.cn或.com.cn结尾，政府网站以.gov.cn结尾；2）检查网站底部的备案号和营业执照信息；3）核实网站的SSL证书（地址栏显示锁形图标）；4）通过本文的最新网址导航直接访问，所有收录网址均经过人工审核验证。',
  },
  {
    id: 'faq4',
    question: '网站收录的平台标准是什么？',
    answer: '我们收录的平台遵循以下标准：1）正规合法的互联网平台；2）具有一定用户基础和影响力；3）提供明确的公共服务或商业服务；4）网页运行稳定、访问体验良好。我们拒绝收录任何违法违规或存在安全风险的网站。',
  },
  {
    id: 'faq5',
    question: '遇到失效链接怎么办？',
    answer: '如果您发现任何网址无法正常访问，可以通过关于我们页面的联系方式或反馈表单告知我们。我们的团队会第一时间核实并更新最新网址。您的每一条反馈都能帮助更多用户获得更好的使用体验。',
  },
  {
    id: 'faq6',
    question: '最新网址导航是否收费？',
    answer: '最新网址导航完全免费向所有用户开放。我们的使命是帮助用户快速找到可用、安全、有效的最新网址入口，告别失效链接困扰。我们将始终坚持免费服务的理念，持续更新和优化网址资源。',
  },
];